"use client";

import {sessionSignIn} from "@/service/login.service";
import {NextPage} from "next";
import {useEffect} from "react";

interface ManageSesionProps {
  params: PageProps;
}
interface PageProps {
  token: number | string;
}
export const SessionLogin: NextPage<ManageSesionProps> = function ({params}) {
  useEffect(() => {
    sessionSignIn(params.token);
  }, [params.token]);
  return (
    <>
      <div className="flex h-screen w-screen items-center justify-center bg-gray-100">
        <div className="flex flex-col items-center">
          <h4 className="font-extrabold">Loading ... </h4>
          <svg
            className="animate-spin h-16 w-16 text-blue-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
        </div>
      </div>
    </>
  );
};
